let _handler = null;

export function registerConfirmHandler(fn) {
  _handler = fn;
}

export function confirm(message, title = 'Confirm') {
  if (_handler) return _handler(message, title);
  return Promise.resolve(window.confirm(message));
}
